// extracted by mini-css-extract-plugin
export default {"shimmer":"CoinProfile_shimmer__pL1Po","dark_shimmer":"CoinProfile_dark_shimmer__wvrV1","coin_profile":"CoinProfile_coin_profile__kbCLP","no_content":"CoinProfile_no_content__LGnGM"};